import { render, staticRenderFns } from "./AdminHelpCenter.vue?vue&type=template&id=33b0050e&scoped=true&"
import script from "./AdminHelpCenter.vue?vue&type=script&lang=js&"
export * from "./AdminHelpCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0050e",
  null
  
)

export default component.exports